/* tslint:disable */
import {
  Player
} from '../index';

declare var Object: any;
export interface SocialAccountInterface {
  "playerId": any;
  "refId"?: string;
  "alias"?: string;
  "provider": string;
  "accessToken"?: string;
  "profileImage"?: string;
  "name": string;
  "profileUrl"?: string;
  "id"?: any;
  player?: Player;
}

export class SocialAccount implements SocialAccountInterface {
  "playerId": any;
  "refId": string;
  "alias": string;
  "provider": string;
  "accessToken": string;
  "profileImage": string;
  "name": string;
  "profileUrl": string;
  "id": any;
  player: Player;
  constructor(data?: SocialAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SocialAccount`.
   */
  public static getModelName() {
    return "SocialAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SocialAccount for dynamic purposes.
  **/
  public static factory(data: SocialAccountInterface): SocialAccount{
    return new SocialAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SocialAccount',
      plural: 'SocialAccounts',
      path: 'SocialAccounts',
      idName: 'id',
      properties: {
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "refId": {
          name: 'refId',
          type: 'string'
        },
        "alias": {
          name: 'alias',
          type: 'string'
        },
        "provider": {
          name: 'provider',
          type: 'string'
        },
        "accessToken": {
          name: 'accessToken',
          type: 'string'
        },
        "profileImage": {
          name: 'profileImage',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "profileUrl": {
          name: 'profileUrl',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
      }
    }
  }
}
